import script from "./ProductRegisterSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductRegisterSheet.vue?vue&type=script&setup=true&lang=ts"

import "./ProductRegisterSheet.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__